import { NextSeo } from 'next-seo';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { urlHostResolver } from '@/src/lib/utils';
import AboutSideCover from '@/src/views/root/AboutSideCover';

export default function AboutPage() {
  return (
    <AssembleLayout Layout={MainLayout} Component={AboutSideCover}>
      <NextSeo
        title="Sobre"
        description="Em 2017 nascemos com o propósito de tornar o relacionamento comercial e financeira entre instituições de ensino, fornecedores educacionais e seus alunos e responsáveis, algo simples e descomplicado. Nossa plataforma tem como principal objetivo simplificar o consumo de de produtos e serviços educacionais, em qualquer lugar, à qualquer momento. Nosso grande diferencial está em termos construído uma solução que é 100% aderente às necessidades do setor educacional e todas suas complexidades e particularidades."
        openGraph={{
          title: 'Sobre',
          url: urlHostResolver('/about'),
          images: [
            {
              title: 'Sobre',
              url: urlHostResolver(`/images/illustrations/about/hero.png`),
              width: 1125,
              height: 571,
              alt: 'Sobre',
            },
          ],
        }}
      />
    </AssembleLayout>
  );
}
